document.addEventListener('DOMContentLoaded', function () {

    const bandSelect = document.getElementById('band-select');
    const cupSelect = document.getElementById('cup-select');
    const resultDisplay = document.querySelector('.show-result');
    const fitResultContainer = document.querySelector('.fit-size-result');
    const allFitTexts = document.querySelectorAll('.text-result');

    const track = document.getElementById('slider-track');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');
    const allSlides = document.querySelectorAll('.list-slide');
    const noImgMsg = document.querySelector('.no-img');

    let currentIndex = 0;
    let visibleSlides = [];
    let autoSlideInterval;

    track.style.cursor = 'grab';
    track.style.touchAction = 'pan-y';
    track.style.userSelect = 'none';

    const sizeMapping = {
        '28A': 'AA','30A': 'AA','32A': 'AA','34A': 'A','36A': 'B','38A': 'C','40A': 'D','42A': 'E','44A': 'F',
        '28B': 'AA','30B': 'AA','32B': 'A','34B': 'B','36B': 'C','38B': 'D','40B': 'E','42B': 'F','44B': 'G',
        '28C': 'AA','30C': 'A','32C': 'B','34C': 'C','36C': 'D','38C': 'E','40C': 'F','42C': 'G','44C': 'H',
        '28D': 'A','30D': 'B','32D': 'C','34D': 'D','36D': 'E','38D': 'F','40D': 'G','42D': 'H','44D': 'I',
        '28DD/E': 'B','30DD/E': 'C','32DD/E': 'D','34DD/E': 'E','36DD/E': 'F','38DD/E': 'G','40DD/E': 'H','42DD/E': 'I','44DD/E': 'J',
        '28DDD/F': 'C','30DDD/F': 'D','32DDD/F': 'E','34DDD/F': 'F','36DDD/F': 'G','38DDD/F': 'H','40DDD/F': 'I','42DDD/F': 'J','44DDD/F': 'K',
        '28G': 'D','30G': 'E','32G': 'F','34G': 'G','36G': 'H','38G': 'I','40G': 'J','42G': 'K','44G': 'L',
        '28H': 'E','30H': 'F','32H': 'G','34H': 'H','36H': 'I','38H': 'J','40H': 'K','42H': 'L','44H': 'M',
        '28I': 'F','30I': 'G','32I': 'H','34I': 'I','36I': 'J','38I': 'K','40I': 'L','42I': 'M','44I': 'N',
        '28J': 'G','30J': 'H','32J': 'I','34J': 'J','36J': 'K','38J': 'L','40J': 'M','42J': 'N','44J': 'O',
        '28K': 'H','30K': 'I','32K': 'J','34K': 'K','36K': 'L','38K': 'M','40K': 'N','42K': 'O','44K': 'P',
        '28L': 'I','30L': 'J','32L': 'K','34L': 'L','36L': 'M','38L': 'N','40L': 'O','42L': 'P','44L': 'Q',
        '28M': 'J','30M': 'K','32M': 'L','34M': 'M','36M': 'N','38M': 'O','40M': 'P','42M': 'Q','44M': 'R',
        '28N': 'K','30N': 'L','32N': 'M','34N': 'N','36N': 'O','38N': 'P','40N': 'Q','42N': 'R',
        '28O': 'L','30O': 'M','32O': 'N','34O': 'O','36O': 'P','38O': 'Q','40O': 'R',
        '28P': 'M','30P': 'N','32P': 'O','34P': 'P','36P': 'Q','38P': 'R',
        '28Q': 'N','30Q': 'O','32Q': 'P','34Q': 'Q','36Q': 'R',
        '28R': 'O','30R': 'P','32R': 'Q','34R': 'R',
        '28S': 'P','30S': 'Q','32S': 'R',
        '28T': 'Q','30T': 'R',
        '28U': 'R'
    };

    function checkAvailability() {
        const selectedBand = bandSelect.value;
        const selectedCup = cupSelect.value;

        Array.from(cupSelect.options).forEach(option => {
            if (option.value === "") return;
            if (selectedBand) {
                option.disabled = !sizeMapping[selectedBand + option.value];
            } else {
                option.disabled = false;
            }
        });

        Array.from(bandSelect.options).forEach(option => {
            if (option.value === "") return;
            if (selectedCup) {
                option.disabled = !sizeMapping[option.value + selectedCup];
            } else {
                option.disabled = false;
            }
        });
    }

    function updateCalculator() {
        checkAvailability();
        const band = bandSelect.value;
        const cup = cupSelect.value;

        if (band && cup) {
            const combination = band + cup;
            const resultSize = sizeMapping[combination];

            if (resultSize) {
                resultDisplay.textContent = "BOOMBA talla " + resultSize;
                fitResultContainer.style.display = 'block';
                allFitTexts.forEach(el => el.style.display = 'none');

                const activeText = document.querySelector(`.fit-result-${resultSize.toLowerCase()}`);
                if(activeText) activeText.style.display = 'block';

                filterSlides(resultSize);
            } else {
                resultDisplay.textContent = "talla not available";
                fitResultContainer.style.display = 'none';
                filterSlides('NONE');
            }
        }
    }

    function filterSlides(targetSize) {
        currentIndex = 0;
        track.style.transform = `translateX(0)`;
        visibleSlides = [];

        allSlides.forEach(slide => {
            const slideSize = slide.getAttribute('data-size');
            if (targetSize !== 'NONE' && (targetSize === 'ALL' || slideSize === targetSize)) {
                slide.classList.remove('hide-slide');
                visibleSlides.push(slide);
            } else {
                slide.classList.add('hide-slide');
            }
        });

        if (visibleSlides.length === 0) {
            noImgMsg.style.display = 'block';
        } else {
            noImgMsg.style.display = 'none';
        }

        updateArrows();
        startAutoSlide();
    }

    function getSliderConfig() {
        const width = window.innerWidth;
        if (width <= 600) {
            return { itemsPerView: 1, slideWidth: 70, centerMode: true };
        } else if (width <= 900) {
            return { itemsPerView: 2, slideWidth: 50, centerMode: false };
        } else {
            return { itemsPerView: 3, slideWidth: 33.333, centerMode: false };
        }
    }

    function updateSliderPosition() {
        if (visibleSlides.length === 0) return;

        const config = getSliderConfig();
        let offset = 0;

        if (config.centerMode) {
            offset = (100 - config.slideWidth) / 2;
        }

        const moveAmount = -(currentIndex * config.slideWidth) + offset;
        track.style.transform = `translateX(${moveAmount}%)`;
        updateArrows();
    }

    function updateArrows() {
        const config = getSliderConfig();

        if (visibleSlides.length === 0 || visibleSlides.length <= config.itemsPerView) {
            if(!config.centerMode || visibleSlides.length === 1) {
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';
                return;
            }
        }

        prevBtn.style.display = 'block';
        nextBtn.style.display = 'block';

        let maxIndex;
        if (config.centerMode) {
            maxIndex = visibleSlides.length - 1;
        } else {
            maxIndex = visibleSlides.length - config.itemsPerView;
        }

        prevBtn.disabled = currentIndex === 0;
        prevBtn.style.opacity = currentIndex === 0 ? '0.3' : '1';

        nextBtn.disabled = currentIndex >= maxIndex;
        nextBtn.style.opacity = currentIndex >= maxIndex ? '0.3' : '1';
    }

    function goNext() {
        const config = getSliderConfig();
        let maxIndex;

        if (config.centerMode) {
            maxIndex = visibleSlides.length - 1;
        } else {
            maxIndex = visibleSlides.length - config.itemsPerView;
        }

        if (currentIndex < maxIndex) {
            currentIndex++;
        } else {
            currentIndex = 0;
        }

        updateSliderPosition();
    }

    function goPrev() {
        if (currentIndex > 0) {
            currentIndex--;
        } else {
            currentIndex = visibleSlides.length - 1;
        }

        updateSliderPosition();
    }

    function startAutoSlide() {
        clearInterval(autoSlideInterval);
        autoSlideInterval = setInterval(() => {
            goNext();
        }, 3000);
    }

    bandSelect.addEventListener('change', updateCalculator);
    cupSelect.addEventListener('change', updateCalculator);

    nextBtn.addEventListener('click', () => {
        goNext();
        startAutoSlide();
    });

    prevBtn.addEventListener('click', () => {
        goPrev();
        startAutoSlide();
    });

    window.addEventListener('resize', function() {
        updateSliderPosition();
        updateArrows();
    });

    track.addEventListener('mouseenter', () => clearInterval(autoSlideInterval));
    track.addEventListener('mouseleave', startAutoSlide);

    let startX = 0;
    let endX = 0;
    let isDragging = false;

    track.addEventListener('touchstart', (e) => {
        startX = e.changedTouches[0].screenX;
        clearInterval(autoSlideInterval);
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].screenX;
        handleSwipe();
        startAutoSlide();
    }, { passive: true });

    track.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.screenX;
        track.style.cursor = 'grabbing';
        clearInterval(autoSlideInterval);
        e.preventDefault();
    });

    track.addEventListener('mouseup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        endX = e.screenX;
        track.style.cursor = 'grab';
        handleSwipe();
        startAutoSlide();
    });

    track.addEventListener('mouseleave', () => {
        if (isDragging) {
            isDragging = false;
            track.style.cursor = 'grab';
        }
    });

    function handleSwipe() {
        const threshold = 50;

        if (endX < startX - threshold) {
            goNext();
        }

        if (endX > startX + threshold) {
            goPrev();
        }
    }

    filterSlides('ALL');
    checkAvailability();
    startAutoSlide();
});